import {
  type ChatPersistedMessage,
  type SendChatFeedbackRequest,
} from '@blaze-dashboard/ai-chat-domain';

export const POLLING_INTERVAL = 3000;

export const CLIENT_ID_PREFIX = 'client-';

export function getNewClientId(): string {
  return `${CLIENT_ID_PREFIX}${crypto.randomUUID()}`;
}

export function isClientId(id: string): boolean {
  return id.startsWith(CLIENT_ID_PREFIX);
}

export type ChatMessage = ChatPersistedMessage;

export type SentFeedback = Record<string, SendChatFeedbackRequest | undefined>;
